import React from 'react';
import styled from 'styled-components';
import EsItemsListContainer from '../../containers/es/EsItemListContainer'
import EsMainTab from './EsMainTab';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import {isMobileOnly} from 'react-device-detect';
import * as CONSTANTS from '../../lib/util/Constants';

const EsMainBlock = styled.div`
    padding: 60px 0 120px;
    max-width: 1176px;
    margin: 0 ${isMobileOnly?"4vw":"auto"};
    .header-title {
      font-size: 18px;
      min-height: 50px;
      b {font-weight:bold;}
    }
    .ea_num {font-weight:700;}
    .info-concurrency-wrapper {
      ${isMobileOnly?`margin:20px 0`:`display: flex;align-items: center;justify-content: center;`};
      color: #333;
      font-size: 14px;
      ${isMobileOnly?`
      .es-amount {
        color: #333;
        font-size: 14px;        
        }      
      `:`
        .es-amount {
          position: absolute;
          top: -105px;
          right: 0;
          color: #333;
          font-size: 14px;
          & b {
          color: #111;
          font-weight: 700;
          }          
        }
              
      `
      }
      }
`;

const InfoPopOverBlock = styled.span`
      .accent {color:red; font-weight: bold;}
      
      .fa-question-circle {
        .info-concurrency {
          display:none; 
          position:absolute; 
          background-color:#fff; 
          border:1px solid #999; 
          animation: fadeOut ease 2s;
          //width:100%;
          padding:15px;
          top:20px; 
          right:0;
          .title {font-weight:700; font-size:1.1rem;}
          .description {font-weight:300; font-size:0.9rem; padding:10px 0;}
          }
      &:hover, &:active {
        .info-concurrency {display:block; animation: fadeIn ease 1s;z-index:10;}
      }
        @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
        }
        @keyframes fadeOut {
        0% {opacity:1;}
        100% {opacity:0;}
        }
              
    }

`;
const MAX_CNT = CONSTANTS.MAX_RQST_CNT;

const EsMainList = () => {

    const [availCnt, setAvailCnt] = useState(MAX_CNT);
    const [curIdx, setCurIdx] = useState(0);
    var { nickname, esItems, accessToken, loading } = useSelector(
        ({ userReducer, esItemsReducer, loadingReducer }) => ({
            nickname: userReducer.nickname,
            esItems: esItemsReducer.esItems,
            accessToken: userReducer.accessToken,
            loading: loadingReducer['esitem/LIST_ES'],
        })
    );

    useEffect(() => {

        if (esItems !== null && esItems !== undefined) {
            const cnt = (MAX_CNT - esItems.length) < 0 ? 0 : MAX_CNT - esItems.length
            try {
                if (esItems[0][0].rqst_status !== '050106') {
                    setAvailCnt(cnt)
                }
            } catch (e) { }

        }

    }, [nickname, esItems, accessToken])

    const infoConcurrency = () => {return(
      <InfoPopOverBlock>
          <i className="fas fa-question-circle">
              <div className="info-concurrency">
                  <div className="title">견적진행 가능수량이란?</div>
                  <div className="description">
                      <p>어디가구에서는 과도한 견적 의뢰를 막고자</p>
                      <p>동시에 진행가능한 견적 의뢰 건수를 <span className="accent">{MAX_CNT}건</span></p>
                      <p>까지로 제한하고 있습니다.</p><br/><br/>
                      <p>진행중인 견적 의뢰 건 중 최소 한건 이상이</p>
                      <p> 완료되면 새롭게 견적 요청이 가능하오니 </p>
                      <p>이용에 참고 부탁드립니다.</p>
                  </div>
              </div>
          </i>
      </InfoPopOverBlock>)
    }

    return (
        <EsMainBlock>


            {isMobileOnly&&
                <div className="header-title">
                    <div style={{ display: accessToken === null || loading ? 'none' : 'block' }}><b>{nickname}</b>님,</div>
                    <div style={{ display: accessToken === null || loading ? 'none' : 'block' }}>가구견적 비교하세요!</div>
                </div>}

            <div className="sz-wrap p-re">
                <div className="info-concurrency-wrapper">
                <div className="es-amount" style={{ display: accessToken === null || loading ? 'none' : 'block' }}>
                    {isMobileOnly?"현재":<><b style={{ fontWeight: '600' }}>{nickname}</b>님의 </>} <span className="underline">견적 진행 가능 수량은 <b className="ea_num"> {availCnt} </b>개 </span>
                        입니다.
                    &nbsp;&nbsp;{infoConcurrency()}
                </div>

                </div>
                <div id="esSection" className="filter-wrap">
                    <div id="esSection" className="filter-wrap">
                        <EsMainTab
                            tabList={[{ index: 0, title: "견적서" },
                            { index: 1, title: "주문 완료 견적서" }]}
                            handleTabClick={(value) => { setCurIdx(value) }} />
                        <EsItemsListContainer curIdx={curIdx} />
                    </div>
                </div>
            </div>
        </EsMainBlock >
    );
};

export default EsMainList;
